import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';
import { _logOut } from 'src/services/redux/slices/auth/auth-slice';

// import * as auth from './redux/AuthRedux'

export function Logout() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(_logOut());
  }, [dispatch]);

  return null;
  // return (
  //   <Switch>
  //     <Redirect to="/auth/login" />
  //   </Switch>
  // );
}
